export default __webpack_public_path__ + "static/media/partner.0b284a0c.svg";